export default class AlertBoxController {
    /** @ngInject */
    constructor(NotificationsApi) {
        this.NotificationsApi = NotificationsApi;
    }

    $onInit() {
        this.notification = null;
        this.severity = null;
        this.severities = {
            INFO: {
                cls: 'info',
                icon: 'fa-info'
            },
            WARNING: {
                cls: 'warn',
                icon: 'fa-warning'
            },
            ALERT: {
                cls: 'alert',
                icon: 'fa-exclamation-circle'
            }
        };
    }

    getSeverity(notification) {
        return this.severities[notification.level];
    }

    $onChanges(changes) {
        if (changes.selectedThingId && changes.selectedThingId.currentValue) {
            this.selectedThingId = changes.selectedThingId.currentValue;
            this.loadNotifications();
        }
    }

    loadNotifications() {
        this.NotificationsApi.getByObjectId(this.selectedThingId).then((data) => {
            const notifications = data.notifications || [];
            this.notification = notifications.pop();
            if (this.notification) {
                this.severity = this.getSeverity(this.notification);
            } else {
                this.severity = null;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/alert-box/alert-box.controller.js